// extracted by mini-css-extract-plugin
module.exports = {"title-container":"TitleContainer_title-container__7mnXO","title-text":"TitleContainer_title-text__qPAiF","title-description":"TitleContainer_title-description__pnho_"};